import { render, staticRenderFns } from "./Resolve.vue?vue&type=template&id=681539da&scoped=true"
import script from "./Resolve.vue?vue&type=script&lang=ts"
export * from "./Resolve.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681539da",
  null
  
)

export default component.exports